import { type Round } from '@h2h/shared';

// Left-edge accents for the real-competition standings.
export const QUALIFY_COLOR = '#0BA078'; // group winner / runner-up → through
export const PLAYOFF_COLOR = '#E3A82B'; // 3rd → best-of play-off hunt

export const isLetteredGroup = (name: string) => /^group\s+[a-z]$/i.test(name.trim());

// Canonical 48-team knockout path. Matched against each round's provider label so
// stages light up as their fixtures get published; until then the bracket is locked.
export const KNOCKOUT_STAGES: { match: RegExp; label: string }[] = [
  { match: /round of 32/i, label: 'Round of 32' },
  { match: /round of 16/i, label: 'Round of 16' },
  { match: /quarter/i, label: 'Quarter-finals' },
  { match: /semi/i, label: 'Semi-finals' },
  { match: /3rd place|third/i, label: 'Third-place play-off' },
  { match: /final/i, label: 'Final' }
];

export function stageDate(round: Round): string {
  return new Date(round.firstKickoffAt).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
}

export const BORDER_COLOR: Record<'ucl' | 'europa' | 'relegation', string> = {
  ucl: '#1E5BB8',
  europa: '#E3A82B',
  relegation: '#D2544F'
};
